export const UCARDIA_API_BASE_URL = process.env.REACT_APP_UCARDIA_API_BASE_URL;
export const SEND_NOTIFICATIONS_URL =
	process.env.REACT_APP_SEND_NOTIFICATION_URL;
